/**
 * FooterNav
 * ======================================
 */
 const ISMOBILE = window.matchMedia("only screen and (max-width: 992px)").matches
 const ELEMENTS = ".js-FooterNav";
 const SUBNAV = '.footer-nav__item-subnav'
 const TOGGLE_CLASS = "is-toggled";

 class FooterNav {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS);

     if (!this.elements || !ISMOBILE) {
       return false;
     }

     this.elements.forEach((el) => {
       el.addEventListener("click", this.toggle);
     });
   }

   toggle = (e) => {
     const el = e.currentTarget;
     const parent = el.parentNode;
     const target = parent.querySelector(SUBNAV);
     const classes = parent.classList

     if (!target) {
       return false;
     }

     if(classes.contains(TOGGLE_CLASS)){
      classes.remove(TOGGLE_CLASS)
      target.style.height = 0
    } else {
      classes.add(TOGGLE_CLASS)
      target.style.height = target.scrollHeight+'px'
    }

     e.preventDefault();
   };
 }

 new FooterNav();
